import { Json } from '@homeleite/arch';
export class HomeleiteTenant {
  constructor(public readonly id = '', public readonly name = '') {}

  static fromJson(json: any): HomeleiteTenant {
    return json ? Json.from.simple(json, HomeleiteTenant) : null;
  }
}
